import type Listing from './types/listing';

export function sortListingsByDate<T = unknown>(listings: (Pick<Listing, 'addedAt'> & T)[]) {
  return listings.sort((a, b) => a.addedAt < b.addedAt ? 1 : -1);
}

export function sortListingsByThumbnail<T = unknown>(listings: (Pick<Listing, 'imageUrl'> & T)[]) {
  return listings.sort(a => a.imageUrl ? -1 : 1);
}

type ValueGetter<T = unknown> = (item: T) => string | number;

export const ASCENDING_ORDER = 'ascending';
export const DESCENDING_ORDER = 'descending';
export type SortingOrder = typeof ASCENDING_ORDER | typeof DESCENDING_ORDER;

export function sortBy<T>(array: T[], key: ValueGetter<T>, order: SortingOrder = ASCENDING_ORDER) {
  if (order === ASCENDING_ORDER) {
    return [...array].sort((a, b) => key(a) > key(b) ? 1 : -1 );
  }
  return [...array].sort((a, b) => key(a) > key(b) ? -1 : 1 );
}

export function toJson(data: unknown) {
  return JSON.parse(JSON.stringify(data));
}